const statusStyle = (status) => {
  switch (status) {
    case 'answered': return 'bg-emerald-500 text-white shadow-sm';
    case 'marked':   return 'bg-amber-400 text-white shadow-sm';
    case 'current':  return 'bg-primary-500 text-white shadow-md ring-2 ring-primary-300 scale-110';
    default:         return 'bg-slate-700 text-slate-300 hover:bg-slate-600';
  }
};

const Legend = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <span className={`w-3 h-3 rounded ${color}`} />
    <span className="text-xs text-slate-400">{label}</span>
  </div>
);

const QuestionButton = ({ i, current, answeredSet, markedSet, onNavigate }) => {
  let status = 'unanswered';
  if (i === current) status = 'current';
  else if (markedSet?.has(i)) status = 'marked';
  else if (answeredSet?.has(i)) status = 'answered';
  return (
    <button
      onClick={() => onNavigate(i)}
      className={`w-9 h-9 rounded-lg text-xs font-semibold transition-all duration-150 ${statusStyle(status)}`}
    >
      {i + 1}
    </button>
  );
};

const NavigationPanel = ({ total, current, answeredSet, markedSet, onNavigate, sectionStructure }) => {
  const hasSections = sectionStructure?.length > 0 && sectionStructure.some((s) => s.name);

  return (
    <div className="bg-slate-800 rounded-2xl border border-slate-700 p-4">
      <p className="text-xs font-semibold text-slate-400 mb-3 uppercase tracking-wide">Questions</p>

      {hasSections ? (
        <div className="space-y-4">
          {sectionStructure.map((sec, gi) => (
            <div key={gi}>
              {sec.name && (
                <p className="text-xs font-semibold text-primary-400 uppercase tracking-wide mb-2 truncate">
                  {sec.name}
                </p>
              )}
              <div className="grid grid-cols-5 gap-1.5">
                {Array.from({ length: sec.count }, (_, k) => {
                  const i = sec.startIndex + k;
                  return (
                    <QuestionButton
                      key={i}
                      i={i}
                      current={current}
                      answeredSet={answeredSet}
                      markedSet={markedSet}
                      onNavigate={onNavigate}
                    />
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-5 gap-1.5">
          {Array.from({ length: total }, (_, i) => (
            <QuestionButton
              key={i}
              i={i}
              current={current}
              answeredSet={answeredSet}
              markedSet={markedSet}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}

      <div className="mt-4 space-y-1.5">
        <Legend color="bg-emerald-500" label="Answered" />
        <Legend color="bg-amber-400" label="Marked for Review" />
        <Legend color="bg-primary-500" label="Current" />
        <Legend color="bg-slate-700" label="Not Answered" />
      </div>
    </div>
  );
};

export default NavigationPanel;
